import React, { Fragment, useContext } from 'react';
import { imageSet } from '../../../../helper/Images';
import { Image } from '../../../../commonComponents';
import PropTypes from 'prop-types';
import Context from '../../../../context';
import { ClickLayer } from '../../../../../ga4';

const Product = ({ item, onClick, active, recommended }) => {
  const { lensCleared, isIframe, isAuth } = useContext(Context);
  const className = active === true ? 'active' : '';
  const getClass = () =>
    item.name.match(new RegExp('<sub>', 'g'))
      ? 'contains-sub'
      : item.name.match(new RegExp('<sup>', 'g'))
      ? 'contains-sup'
      : 'contains-text';
  const isNew = item.is_new && item.is_new === 'yes' ? ' new':'';

  return (
    <Fragment>
      <li
        onClick={() => {
          onClick(item.guid);
          ClickLayer('choosepalette');
        }}
        className={`palette--item palette--item__lens palette--${item.key} ${className}${isNew}`}
      >
        <figure
          className={`palette--item__icon-wrapper${
            recommended && !lensCleared && !isIframe ? ' show' : ''
          }`}
        >
          <Image
            className={`palette--item__image-icon${
              recommended && !lensCleared && !isIframe ? ' show' : ''
            }`}
            src={imageSet[item.star_img]}
            alt="Recommendation"
          />
        </figure>
        <figure className="palette--item__image-wrapper">
          <Image
            className="palette--item__image-lens"
            src={imageSet[item.icon]}
            alt={imageSet[item.name]}
          />
          <figcaption
            className={`palette--item__image-name ${getClass()}`}
            dangerouslySetInnerHTML={{ __html: item.name }}
          />
        </figure>
        {!item.availability && (
          <span className="not-available">Not Available</span>
        )}
      </li>
    </Fragment>
  );
};

Product.propTypes = {
  item: PropTypes.shape({
    availability: PropTypes.number,
    big_img: PropTypes.string,
    box_img: PropTypes.string,
    guid: PropTypes.string,
    icon: PropTypes.string,
    icon_star: PropTypes.string,
    key: PropTypes.string,
    look: PropTypes.string,
    name: PropTypes.string,
    promotion: PropTypes.string,
    recommended_look: PropTypes.string,
    small_img: PropTypes.string,
    specs: PropTypes.arrayOf(
      PropTypes.shape({
        desc: PropTypes.array,
        icon: PropTypes.string,
        title: PropTypes.string,
      })
    ).isRequired,
    star_img: PropTypes.string,
  }),
  onClick: PropTypes.func,
  active: PropTypes.bool,
  recommended: PropTypes.bool,
};

export default Product;
